import React from 'react';
import { useVersionCheck } from '../hooks/useVersionCheck';
import { RefreshCw, X } from 'lucide-react';

export default function UpdateBanner() {
  const { updateAvailable, refreshApp, dismissUpdate } = useVersionCheck();

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg">
      <div className="px-3 py-3 sm:px-4">
        {/* Mobile Layout */}
        <div className="sm:hidden">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-start gap-2 flex-1 min-w-0">
              <RefreshCw className="w-5 h-5 mt-0.5 flex-shrink-0 animate-spin" />
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm">Update available!</p>
                <p className="text-xs text-blue-100 mt-0.5">Tap to refresh</p>
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <button
                onClick={refreshApp}
                className="bg-white text-blue-600 px-3 py-2 rounded-lg text-sm font-medium active:bg-blue-50 transition-colors"
              >
                Refresh
              </button>
              <button
                onClick={dismissUpdate}
                className="p-2 active:bg-blue-800 rounded-lg transition-colors"
                aria-label="Dismiss"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden sm:flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <RefreshCw className="w-5 h-5 animate-spin" />
            <div>
              <p className="font-semibold">New version available!</p>
              <p className="text-sm text-blue-100">Tap to refresh and get the latest updates.</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={refreshApp}
              className="bg-white text-blue-600 px-4 py-2 rounded-lg font-medium hover:bg-blue-50 transition-colors"
            >
              Refresh
            </button>
            <button
              onClick={dismissUpdate}
              className="p-2 hover:bg-blue-800 rounded-lg transition-colors"
              aria-label="Dismiss"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
